if (!customElements.get('pdp-drawer')) {
  class PdpDrawer extends HTMLElement {
    connectedCallback() {
      this.overlay = this.querySelector('.pdp-drawer__overlay');
      this.openBtn = this.querySelector('.pdp-drawer__open');
      this.closeBtn = this.querySelector('.pdp-drawer__close');
      if (!this.overlay || !this.openBtn) return;

      this.onKey = (e) => { if (e.key === 'Escape') this.close(); };
      this.openBtn.addEventListener('click', () => this.open());
      this.closeBtn?.addEventListener('click', () => this.close());
      this.overlay.addEventListener('click', (e) => {
        if (e.target === this.overlay) this.close();
      });
    }

    open() {
      // Move the overlay to <body> so it escapes any transformed/sticky
      // ancestor stacking context and reliably covers the whole page.
      if (this.overlay.parentElement !== document.body) {
        document.body.appendChild(this.overlay);
      }
      this.overlay.hidden = false;
      // Next frame so the slide-in transition runs.
      requestAnimationFrame(() => this.overlay.classList.add('is-open'));
      document.addEventListener('keydown', this.onKey);
      document.documentElement.style.overflow = 'hidden';
      this.closeBtn?.focus();
    }

    close() {
      this.overlay.classList.remove('is-open');
      document.removeEventListener('keydown', this.onKey);
      document.documentElement.style.overflow = '';
      const hide = () => { this.overlay.hidden = true; };
      this.overlay.addEventListener('transitionend', hide, { once: true });
      setTimeout(hide, 400);
      this.openBtn?.focus();
    }
  }
  customElements.define('pdp-drawer', PdpDrawer);
}

/* Mobile trust-icon slider: arrows page through the icons a screenful at a
   time (2-up on mobile) and only appear when there's more to scroll. The
   slider also auto-advances every 4s, looping back to the start at the end.
   Autoplay pauses on touch and resets after an arrow tap. Arrow clicks must
   not toggle the surrounding <details>. */
(function () {
  var AUTO_MS = 4000;

  function initTrustSliders() {
    document.querySelectorAll('.pdp-trust__slider').forEach((slider) => {
      if (slider.dataset.sliderInit) return;
      slider.dataset.sliderInit = '1';

      const scroller = slider.querySelector('.pdp-trust__icons');
      const prev = slider.querySelector('.pdp-trust__arrow--prev');
      const next = slider.querySelector('.pdp-trust__arrow--next');
      if (!scroller || !prev || !next) return;

      const maxScroll = () => scroller.scrollWidth - scroller.clientWidth;
      const isScrollable = () => maxScroll() > 4;

      const advance = (dir) => {
        if (dir > 0 && scroller.scrollLeft >= maxScroll() - 2) {
          scroller.scrollTo({ left: 0, behavior: 'smooth' }); // wrap forward to start
        } else if (dir < 0 && scroller.scrollLeft <= 2) {
          scroller.scrollTo({ left: maxScroll(), behavior: 'smooth' }); // wrap back to end
        } else {
          scroller.scrollBy({ left: dir * scroller.clientWidth, behavior: 'smooth' });
        }
      };

      let timer = null;
      const startAuto = () => {
        stopAuto();
        timer = setInterval(() => { if (isScrollable()) advance(1); }, AUTO_MS);
      };
      const stopAuto = () => { if (timer) { clearInterval(timer); timer = null; } };

      const onArrow = (dir) => (e) => {
        e.preventDefault();
        e.stopPropagation();
        advance(dir);
        startAuto(); // reset the timer so it doesn't jump right after a tap
      };
      prev.addEventListener('click', onArrow(-1));
      next.addEventListener('click', onArrow(1));

      // Pause while the user is interacting, resume afterwards.
      scroller.addEventListener('pointerdown', stopAuto);
      scroller.addEventListener('pointerup', startAuto);
      scroller.addEventListener('pointercancel', startAuto);
      scroller.addEventListener('touchstart', stopAuto, { passive: true });
      scroller.addEventListener('touchend', startAuto, { passive: true });

      const update = () => {
        // Show both arrows whenever there's anything to scroll (they loop at
        // each end) rather than hiding one — the toggling made them "jump".
        const scrollable = isScrollable();
        prev.hidden = !scrollable;
        next.hidden = !scrollable;
      };
      scroller.addEventListener('scroll', update);
      window.addEventListener('resize', update);
      setTimeout(update, 120);
      startAuto();
    });
  }

  if (document.readyState !== 'loading') initTrustSliders();
  else document.addEventListener('DOMContentLoaded', initTrustSliders);
})();
